export default "__VITE_ASSET__CzPNj5BQ__"